import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Modal } from 'reactstrap'
import { Theme } from '@pga/pga-component-library'
import { StyledButton as Button } from '../../styles'

const { colors } = Theme

export const StyledModal = styled(Modal)`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 400px;
  & .modal-content {
    align-items: center;
    padding: 40px 55px;
    border-radius: 8px;
  }
  & .close {
    position: absolute; 
    right: 15px;
    top: 8px;
    font-weight: 300;
    font-size: 1.7rem;
    z-index: 1;
  }
`

export const StyledModalWithBack = styled(
  ({ className, ...props }) => <StyledModal {...props} backdropClassName={className} />
)`
  background-color: ${colors.primary};
`

export const StyledLogoWrapper = styled.div`
  width: 160px;
  margin-bottom: 33px;
`

export const StyledLogoImg = styled.img`
  object-fit: contain;
  width: 100%;
`

export const StyledTitle = styled.div`
  margin-bottom: 8px;
  color: ${props => props.theme.colors.secondary};
  font-family: ${props => props.theme.fonts.body};
  font-size: 26px;
  font-weight: bold;
`

export const StyledInfo = styled.div`
  margin-bottom: 35px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
`

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 100%;
  height: 47px;
  font-family: ${Theme.fonts.Montserrat};
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
`

export const StyledDivider = styled.div`
  margin-bottom: 28px;
  height: 1px;
  width: 100%;
  border: 1px solid ${colors.greyBlue};
`

export const StyledFooterInfo = styled.div`
  font-family: ${Theme.fonts.Montserrat};
  font-size: 14px;
  font-weight: 500;
  color: ${colors.primary};
`

export const StyledButtonLink = styled(Link)`
  margin-bottom: 35px;
  width: 100%;
  color: inherit;
  :hover {
    text-decoration: none;
  }
`
